import { render, staticRenderFns } from "./HeroItem.vue?vue&type=template&id=2621d04a&lang=pug&"
import script from "./HeroItem.vue?vue&type=script&lang=js&"
export * from "./HeroItem.vue?vue&type=script&lang=js&"
import style0 from "./HeroItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VImg,VLayout,VProgressCircular})
